import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";

import appSlice from "features/layouts/landing-layout/slice";
import dashboardSlice from "features/layouts/dashboard-layout/slice";
import loginSlice from "features/login/slice";
import transactionsSlice from "features/transactions-list/slice";
import merchantSlice from "features/account/slice/merchant";
import acceptorSlice from "features/account/slice/acceptor";
import shopAndAcceptorSlice from "features/account/slice/shopAndAcceptor";

const persistConfig = { key: "root", storage };

const reducers = combineReducers({
  app: appSlice,
  login: loginSlice,
  dashboard: dashboardSlice,
  transactions: transactionsSlice,
  merchant: merchantSlice,
  acceptor: acceptorSlice,
  shopAndAcceptor: shopAndAcceptorSlice,
});

const persistedReducer = persistReducer(persistConfig, reducers);
const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: false, // Ignore checking non-serializable actions
  }),
});

const persistor = persistStore(store);
export { store, persistor };
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
